module.exports = __webpack_public_path__ + "img/f5-logo-rgb.d2fc383e.svg";